<template>
  <div id="sidebar">
    <div id="sidebar-brand" class="themed-background">
      <a href="/" class="sidebar-title">
        <span class="sidebar-nav-mini-hide">
          <img src="/images/logo_sig_white_transp.png" style="width: 100px;" />
        </span>
      </a>
    </div>
    <div id="sidebar-scroll">
      <div class="sidebar-content">
        <sidebar-nav :nodos="nav" :ulClass="'sidebar-nav'" />
      </div>
    </div>
    <div id="sidebar-extra-info" class="sidebar-content sidebar-nav-mini-hide">
      <div class="text-center">
        <small>SIG 3.0</small>
        <br />
        <img style="width: 82px;height: 48px;z-index: 22;" src="/images/logo_fga_color_transp.png" />
        <br />
        <small>
          <span id="year-copy"></span> &#xA9;
          <a href="http://www.fga.com.co" target="_blank">FGA Fondo de Garant&#xED;as</a>
        </small>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => {
    return {
      nav: []
    };
  },
  components: {
    SidebarNav: () =>
      import(/* webpackChunkName: "SidebarNav" */ "./SidebarNav")
  },
  created() {
    this.$store
      .dispatch("index", { endpoint: "modulo" })
      .then(response => {
        this.nav = response[0].children;
      })
      .catch(() => {
        this.$notify({
          title: "Advertencia!",
          type: "warning",
          content: "Error cargando módulos"
        });
      });
  }
};
</script>

